import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthUtility } from '../../core/utility/auth-utility';
import { DashboardPadre } from './views/dashboard-padre/dashboard-padre';
import { DashboardEstudiante } from './views/dashboard-estudiante/dashboard-estudiante';
import { DashboardAdmin } from './views/dashboard-admin/dashboard-admin';

@Component({
    selector: 'app-dashboard',
    imports: [
        CommonModule,
        DashboardPadre,
        DashboardEstudiante,
        DashboardAdmin,
    ],
    templateUrl: './dashboard.html',
    styleUrl: './dashboard.scss'
})
export class Dashboard {

    rol: string = '';

    constructor(private router: Router) {
        this.resolveRole();
    }

    private resolveRole(): void {
        const user = AuthUtility.getValueUserAS();
        const perfil = user?.cPerfil?.toUpperCase() || '';

        if (perfil.includes('PADRE')) {
            this.rol = 'PADRE';
        } else if (perfil.includes('ESTUDIANTE')) {
            this.rol = 'ESTUDIANTE';
        } else if (perfil.includes('DOCENTE')) {
            this.router.navigate(['/estudiantes/mis-estudiantes']);
        } else if (perfil.includes('ADMINISTRADOR') || perfil.includes('DIRECTIVO')) {
            this.rol = 'ADMIN';
        } else if (perfil.includes('AUXILIAR') || perfil.includes('DIRECTOR')) {
            this.router.navigate(['/asistencia-reportes/hoy']);
        } else if (perfil.includes('AUXI-BOT') || perfil.includes('AUXIBOT')) {
            this.router.navigate(['/registro-asistencia']);
        }
    }
}
